module.exports = __webpack_public_path__ + "static/media/choose-payment-plan.d883bcf0.svg";